import React, { useEffect, useState } from 'react'
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Fab,
  ButtonGroup,
  ToggleButtonGroup,
  ToggleButton,
  Typography,
  Stack,
  Chip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useDispatch, useSelector } from "src/stateManagement/redux";
import { useForm } from "src/shared/hooks/useForm";
import FlagIcon from '@mui/icons-material/Flag';
import WarningIcon from '@mui/icons-material/Warning';
import { createLocationTag } from 'src/stateManagement/redux/slices/location/asyncReducers';

interface Props {
  showModalTags: boolean;
  handleModalTags: any;
  activeEditTag: any;
  tags: any[];
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const ModalComponent = ({ showModalTags, handleModalTags, tags, activeEditTag }: Props) => {

  const dispatch = useDispatch();

  const { locationId, locationTags } = useSelector(
    (state) => state.location
  );

  const [alignment, setAlignment] = React.useState('flag');

  const [activeTags, setActiveTags] = useState<any[]>([])

  const [activeTag, setActiveTag] = useState<any>(undefined)


  useEffect(() => {
    const activeTags = tags.filter((tag) => tag.alertType === alignment);
    setActiveTags(activeTags);
  }, [alignment, tags])

  const [formValues, handleInputChange, reset, setNuewValues] = useForm({
    id: undefined,
    tagId: "",
    comment: "",
    value: undefined,
  });

  const { tagId, comment, value, id } = formValues;

  useEffect(() => {

    if (activeEditTag) {
      const { id, tagId, comment, value } = activeEditTag;
      setActiveTag(activeEditTag);
      setAlignment(activeEditTag.alertType);
      setNuewValues({
        id,
        tagId,
        comment,
        value,
      });
    } else {
      reset();
    }
  }, [activeEditTag])


  useEffect(() => {
    if (tagId !== "") {
      const activeTags = tags.find((tag) => tag.id === tagId);
      setActiveTag(activeTags);
    }
  }, [tagId])


  const handleAddTag = () => {
    const data = {
      id,
      locationId,
      tagId,
      comment,
      value,
    };

    dispatch(createLocationTag(data));
    reset();
    setActiveTag(undefined)
    handleModalTags();
  };

  const handleChange = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
    setAlignment(newAlignment);
    setActiveTag(undefined)
    reset();
  };

  return (
    <Modal
      open={showModalTags}
      onClose={handleModalTags}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {/* header close icon */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mb: 2,
          }}
        >
          <IconButton
            aria-label="delete"
            onClick={handleModalTags}
            sx={{
              backgroundColor: "#cf1919",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#ff3535",
              },
              width: 30,
              height: 30,
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Grid container spacing={2}>
          {/* tabs */}
          <Grid size={12} sx={{ display: "flex", justifyContent: "center" }}>
            <ToggleButtonGroup
              color={alignment === "flag" ? "primary" : "warning"}
              value={alignment}
              exclusive
              onChange={activeEditTag?()=>{}:handleChange}
              aria-label="Platform"
            >
              <ToggleButton value="flag" sx={{ display: "flex", flexDirection: "row", width: 130 }}>
                <FlagIcon />
                <Typography>
                  Flag
                </Typography>
              </ToggleButton>
              <ToggleButton value="warning" sx={{ display: "flex", flexDirection: "row", width: 130 }}>
                <WarningIcon />
                <Typography>
                  Warning
                </Typography>
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
          {/* tag list */}
          <Grid size={12}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label">
                Tag
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                label="Variables"
                id="demo-simple-select"
                name="tagId"
                value={tagId}
                onChange={handleInputChange}
                size="small"
                disabled={activeEditTag ? true : false}
              >
                {activeTags?.map((variable: any, index) => {

                  let existPreviousTag = locationTags?.find((tag) => tag.tagId === variable.id);

                  return (
                    <MenuItem
                      value={variable.id}
                      key={index}
                      disabled={existPreviousTag ? true : false}
                    >
                      {variable.name}
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>
          </Grid>
          {/* deppend Variable */}
          {activeTag?.variableName && (
            <Stack direction="row" spacing={1}>
              <Chip label={activeTag?.variableName} color="primary" />
            </Stack>
          )}

          {/* variable value  */}
          {alignment === "warning" && (
            <Grid size={12}>
              <TextField
                fullWidth
                size="small"
                label="Valor de la variable para la alerta"
                value={value || ""}
                name="value"
                onChange={handleInputChange}
              />
            </Grid>
          )}

          {/* comments  */}
          <Grid size={12}>
            <TextField
              fullWidth
              size="small"
              label="Comentario"
              value={comment}
              multiline
              rows={4}
              name="comment"
              onChange={handleInputChange}
            />
          </Grid>
          {/* save button */}
          <Grid size={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              size="small"
              sx={{ mt: 2 }}
              onClick={handleAddTag}
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  )
}
